import React, { useMemo } from "react";
import "./GetStartedWidget.css";
import GetStartedBall from "../../../images/GetStartedBall.png";
import { Progress } from "antd";
import { ChevronRight } from "../../../utils/icons";
import useAdminDataStore, { selectCurrentGroupData, selectGettingStartedExpanded } from "../../../store/adminData/adminData";

const GetStartedWidget = ({ sidenavExpanded }) => {
  const groupData = useAdminDataStore(selectCurrentGroupData);

  const progressPercentage = useMemo(() => {
    if (
      !groupData?.gettingStarted?.totalItems ||
      !groupData?.gettingStarted?.totalCompletedItems ||
      groupData.gettingStarted.totalItems === 0
    ) {
      return null;
    }

    const percentage = (
      (groupData.gettingStarted.totalCompletedItems /
        groupData.gettingStarted.totalItems) *
      100
    ).toFixed(0);

    return isNaN(percentage) ? null : Number(percentage);
  }, [groupData]);

  const expanded = useAdminDataStore(selectGettingStartedExpanded);
  const setGettingStartedExpanded = useAdminDataStore(
    (state) => state.setGettingStartedExpanded,
  );

  const handleExpand = () => {
    if (!expanded) {
      setGettingStartedExpanded(true);
    }
  };

  return (
    <>
      {sidenavExpanded ? (
        <div className="get-started-widget-container" onClick={handleExpand}>
          <div className="get-started-widget-container-header">
            <div className="get-started-widget-container-header-content">
              <img
                src={GetStartedBall}
                alt="get-started-widget"
                height={20}
                width={20}
              />
              <p style={{ fontSize: "14px" }}>Get Started</p>
            </div>
            <div>
              <img src={ChevronRight} alt="chevron-right" />
            </div>
          </div>

          {/* {(progressPercentage !== null || progressPercentage === 0) && ( */}
          <>
            <div className="get-started-widget-container-progress-bar">
              <Progress percent={progressPercentage || 0} showInfo={false} />
            </div>

            <div className="get-started-widget-container-footer">
              <p className="get-started-widget-container-footer-text">
                <span>{progressPercentage || 0}</span>% completed
              </p>
            </div>
          </>
          {/* )} */}
        </div>
      ) : (
        <div
          className="get-started-widget-container-minimized"
          onClick={handleExpand}
        >
          <img
            height={20}
            width={20}
            src={GetStartedBall}
            alt="get-started-widget"
          />
        </div>
      )}
    </>
  );
};

export default GetStartedWidget;
